export default __webpack_public_path__ + "static/media/markup-icon.67f800ae.svg";